export const PageViewEvent = {
    ORDER: 'ORDER',
    WAITING: 'WAITING',
    BRANCH: 'BRANCH',
    GIFTING: 'GIFTING',
    NON_PURCHASABLE: 'NON_PURCHASABLE',
    PAY_APP: 'PAY_APP',
    /** 주문서 진입 */
    SHEET_SHOWN: 'SHEET_SHOWN',
    /** 인증 완료 후 결제중 */
    APPLYING: 'APPLYING',
} as const

export const PageViewLogger = {
    LCS: 'lcs',
} as const

export type PageViewLoggerType = Constant<typeof PageViewLogger>

export type PageViewLoggers = Array<PageViewLoggerType>

export type PageViewValueType = object

export type PageViewEventType = Constant<typeof PageViewEvent>
